module.exports = __webpack_public_path__ + "static/PMPB-fd115f6a01647cb958cebd7e359dc773.png";